import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import MaterialCard from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Text from "../Text/Text";
import { Grid, IconButton } from "@material-ui/core";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import GavelIcon from '@material-ui/icons/Gavel';
const useStyles = makeStyles((theme) => ({
  card: (props) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 5,
    display: "flex",
    flexDirection: "column",
    width: props.fullWidth ? "100%" : "auto",
  }),
  cardContent: (props) => ({
    backgroundColor: theme.palette.background.paper,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    flexGrow: 1,
    // height: props.contentFullHeight ? `calc(100% - ${props.subheader ? 96 : 78}px + 16px)` : 'auto',
    marginTop: theme.spacing(2) * -1,
    zIndex: 0,
  }),
  cardContent2: (props) => ({
    backgroundColor: theme.palette.background.paper,
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    flexGrow: 1,
    // height: props.contentFullHeight ? `calc(100% - ${props.subheader ? 96 : 78}px + 16px)` : 'auto',
    marginTop: theme.spacing(2) * -1,
    zIndex: 0,
  }),

  cardTitle: (props) => ({
    background: theme.palette.error.dark,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    color: !props.variant ? theme.palette.text.primary : "#FFF",
    // height: props.subheader ? 96 : 90,
    padding: 10,
    marginBottom:12,
    // paddingBottom: theme.spacing(3),
    // paddingLeft: theme.spacing(2),
    // paddingRight: theme.spacing(2),
    // paddingTop: theme.spacing(2),
    zIndex: 0,
  }),
  cardTitleInner: (props) => ({
    margin: 0,
    width: "100%",
  }),
  iconContainer: {
    alignItems: "center",
    // display: "flex",
    // width:"5vw",
    // margin:10,
    // paddingRight: theme.spacing(2),

  },
  right: {
    padding:5,
  },
  spacer: {
    flexGrow: 1,
  },
  titleContainer:{
    // width:"85vw",
    // alignItems:"center"
  },
  rightIconsContainer:{
    //   background:"green",
      display:"flex",
      justifyContent:"end"
  }

}));

export const CitationDetailsCard = (props) => {
  const {
    loadingTitle,
    className,
    fullWidth,
    contentFullHeight,
    loading,
    onPdfView,
    onMoney,
    onTool,
    leftIcon,
    variant,
    children,
    title,
    subheader,
    contentStyles,
    align,
    ...remainingProps
  } = props;
  const classes = useStyles(props);
  return (
    <>
      <MaterialCard
        className={clsx(classes.card, className)}
        {...remainingProps}
      >
        <div className={classes.cardTitle}> 
          <div className={classes.iconContainer}>
            <div className=" d-flex align-items-center justify-content-between">
              <div>
                {leftIcon}
               &nbsp; {title}
                {subheader && (
                  <Text variant="subtitle2" color="inherit" align={align}>
                    {subheader}
                  </Text>
                )}
              </div>
              <div>
                {onPdfView && (
                  <IconButton color="inherit" onClick={onPdfView} className={classes.right}>
                    <PictureAsPdfIcon />
                  </IconButton>
                )}
                {onMoney && (
                  <IconButton color="inherit" onClick={onMoney} className={classes.right}>
                    <AttachMoneyIcon />
                  </IconButton>
                )}
                {onTool && (
                  <IconButton color="inherit" onClick={onTool} className={classes.right}>
                    <GavelIcon />
                  </IconButton>
                )}
              </div>
            </div>
          </div>
        
        </div>
        {/* <div >
          <Grid
            className={classes.cardTitleInner}
            container
            // justify="space-around"
            // alignItems="center"
          >
            {
              <Grid item className={classes.iconContainer} xs={1}>
                {leftIcon}
              </Grid>
            }
            <Grid container item className={classes.titleContainer} xs={8}>
              <Grid item justify="center" xs={12}>
                <Text variant="h5" color="inherit" align={align} className="citTitle">
                  {title}
                </Text>
                {subheader && (
                  <Text variant="subtitle2" color="inherit" align={align}>
                    {subheader}
                  </Text>
                )}
              </Grid>
            </Grid>
            {onPdfView && <div className={classes.spacer} />}
            <Grid
              container
              item
              xs={3}
              spacing={2}
              className={classes.rightIconsContainer}
            >
              {onPdfView && (
                <Grid item  xs={2} justify="flex-end">
                  <IconButton color="inherit" onClick={onPdfView} className={classes.right}>
                    <PictureAsPdfIcon />
                  </IconButton>
                </Grid>
              )}
              {onMoney && (
                <Grid item  xs={2} justify="flex-end">
                  <IconButton color="inherit" onClick={onMoney} className={classes.right}>
                    <AttachMoneyIcon />
                  </IconButton>
                </Grid>
              )}
              {onTool && (
                <Grid item  xs={2} justify="flex-end">
                  <IconButton color="inherit" onClick={onTool} className={classes.right}>
                    <GavelIcon />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </Grid>
        </div> */}
        <div className={classes.cardContent2} style={contentStyles}>
          {children}
        </div>
      </MaterialCard>
    </>
  );
};

export { CardContent };
export { CardActions };
